export let COLUMNS = [{
  title: "Int. total",
  dataIndex: "start",
  sorter: (a, b) => a.start - b.start,
}, {
  title: "Int. en cours",
  dataIndex: "current",
  sorter: (a, b) => a.current - b.current,
}, {
  title: "Int. terminées",
  dataIndex: "end",
  sorter: (a, b) => a.end - b.end,
}, {
  title: "Int. plannifiées",
  dataIndex: "current_planned",
  sorter: (a, b) => a.current_planned - b.current_planned,
}, {
  title: "Int. non plannifiées",
  dataIndex: "current_unplanned",
  sorter: (a, b) => a.current_unplanned - b.current_unplanned,
}, {
  title: "Temps moyen des int.",
  children: [{
    title: "Estimés",
    dataIndex: "average_expected_time",
    sorter: (a, b) => a.average_expected_time - b.average_expected_time,
  }, {
    title: "Réel",
    dataIndex: "average_real_time",
    sorter: (a, b) => a.average_real_time - b.average_real_time,
  }],
}, {
  title: "Int. términées",
  children: [{
    title: "À la date estimée",
    dataIndex: "end_by_expected_end_at",
    sorter: (a, b) => a.end_by_expected_end_at - b.end_by_expected_end_at,
  }, {
    title: "À une date différente",
    dataIndex: "end_not_by_expected_end_at",
    sorter: (a, b) => a.end_not_by_expected_end_at - b.end_not_by_expected_end_at,
  }],
}, {
  title: 'SIIPS estimées',
  children: [{
    title: 'Base',
    dataIndex: "expected_siips_base",
    sorter: (a, b) => a.expected_siips_base - b.expected_siips_base,
  }, {
    title: 'Technique',
    dataIndex: "expected_siips_technical",
    sorter: (a, b) => a.expected_siips_technical - b.expected_siips_technical,
  }, {
    title: 'Relationnel',
    dataIndex: "expected_siips_relational",
    sorter: (a, b) => a.expected_siips_relational - b.expected_siips_relational,
  }]
}, {
  title: 'SIIPS réel',
  children: [{
    title: 'Base',
    dataIndex: "real_siips_base",
    sorter: (a, b) => a.real_siips_base - b.real_siips_base,
  }, {
    title: 'Technique',
    dataIndex: "real_siips_technical",
    sorter: (a, b) => a.real_siips_technical - b.real_siips_technical,
  }, {
    title: 'Relationnel',
    dataIndex: "real_siips_technical",
    sorter: (a, b) => a.real_siips_technical - b.real_siips_technical,
  }]
}];